// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__qVkg6","rightAdornment":"Header_rightAdornment__1xk9u"};